export enum ConversationStateEnum {
  idle = "idle",
  testing = "testing",
  testingDevicePermissions = "testingDevicePermissions",
  registration = "registration",
  connecting = "connecting",
  connected = "connected",
  onQueue = "onQueue",
  agentConnected = "agentConnected",
  onCall = "onCall",
  leaving = "leaving",
  error = "error",
  disconnected = "disconnected",
}

export enum CallStateEnum {
  consent = "consent",
  starting = "starting",
  started = "started",
  onHold = "onHold",
  ended = "ended",
  ending = "ending",
  feedback = "feedback",
  completed = "completed",
}

export enum CallAgentStateEnum {
  normal = "normal",
  mutedAudio = "mutedAudio",
}

export enum RegistrationTypeEnum {
  name = "name",
  nameEmailSubject = "nameEmailSubject",
  custom = "custom",
}

export enum ConversationOriginEnum {
  CHAT = "chat",
  WIDGET = "widget",
  CALLBACK = "callback",
  POPUP = "popup",
}

export enum WidgetsEnum {
  video = "video",
  audio = "audio",
  callback = "callback",
  chat = "chat",
  cobrowse = "cobrowse",
  screenshare = "screenshare",
}

export enum DisplayCaptureStateEnum {
  requestingAccess = "requestingAccess",
  loadingStream = "loadingStream",
  sharing = "sharing",
  error = "error",
}

export enum DisplayCaptureDirectionEnum {
  incoming = "incoming",
  outgoing = "outgoing",
}

export enum CobrowseStateEnum {
  idle = "idle",
  ticketRequest = "ticketRequest",
  connecting = "connecting",
  connected = "connected",
  terminating = "terminating",
  paused = "paused",
}

// export enum DisplayCaptureStateEnum {
//   ticketRequest = "ticketRequest",
//   connecting = "connecting",
//   connected = "connected",
//   terminating = "terminating",
// }

export enum CobrowseOriginEnum {
  widget = "widget",
  chat = "chat",
  iFrame = "i-frame",
}

export enum CobrowsePermissionEnum {
  view = "view",
  control = "control",
  displayCapture = "displayCapture",
}

export type CobrowseTerminateReason =
  | "user-denied-access"
  | "user-terminated"
  | "agent-terminated";

export enum UserRoleEnum {
  agent = "AGENT",
  guestAgent = "GUEST_AGENT",
  customer = "CUSTOMER",
  supervisor = "SUPERVISOR", // used only to show all recordings
  admin = "ADMIN",
}

export enum UserCapabilityEnum {
  qrLink = "qr-link",
  arPointer = "ar-pointer",
  coBrowse = "co-browse",
  displayCapture = "display-capture",
  snapshot = "snapshot",
  fileTransfer = "file-transfer",
}

export enum EndpointTypeEnum {
  coBrowse = "co-browse",
  stream = "stream",
  participant = "participant",
  displayCapture = "displayCapture",
}

export const PARAM_KIOSK_MODE = "kiosk";
export const PARAM_CALL_TYPE = "call-type";
export const PARAM_LANG = "lang";
export const PARAM_WIDGET_ORIGIN_URL = "widget-origin-url";
export const PARAM_CONVERSATION_ORIGIN = "corigin";
export const PARAM_COBROWSE_AVAILABLE = "cobrowse-on";
export const PARAM_DISPLAY_NAME = "name";
export const PARAM_MESSAGING = "messaging";

export const POPOUT_WINDOW_TITLE = "Auvious Video";

export const KEY_VIDEO_POPOUT = "auvious.video.popout";
export const KEY_CONVERSATION_TYPE = "auvious.conversation.type";
export const KEY_COBROWSE_PARTICIPANTS = "auvious.cobrowse.participants";
export const KEY_COBROWSE_TICKET = "auvious.ticket";
export const KEY_COBROWSE_REQUEST_TYPE = "auvious.cobrowse.session.type";
export const KEY_REFRESH_TOKEN = "auvious.token.refresh";
export const KEY_COBROWSE_SESSION_ID = "auvious.cobrowse.session";
export const KEY_COBROWSE_USED_TICKETS = "auvious.cobrowse.ticket.used";
export const KEY_SKETCH_CONNECTION_ID = "auvious.sketch.id";
export const KEY_TIME_IN_QUEUE = "auvious.conversation.queue.time";
export const KEY_CALL_ACCEPTED = "auvious.call.accepted";
export const KEY_AGENT_CONNECTED = "auvious.agent.connected";
export const KEY_CALL_USED_TICKETS = "auvious.call.ticket.used";
export const KEY_CALL_TICKET = "auvious.call.ticket";
export const KEY_CONVERSATION_REQUEST = "auvious.conversation.request";
export const KEY_GREETED = "auvious.greeted";

export enum ConferenceMetadataKeyEnum {
  arPointer = "AR_POINTER",
  arPointerColors = "AR_POINTER_COLORS",
  snapshot = "SNAPSHOT",
  sketch = "SKETCH",
}

export enum ColorEnum {
  red = "red",
  green = "green",
  blue = "blue",
  yellow = "yellow",
  orange = "orange",
  purple = "purple",
  gold = "gold",
}

export enum SketchStateEnum {
  idle = "idle",
  started = "started",
}

export enum SketchToolEnum {
  marker = "marker",
  eraser = "eraser",
  arrow = "arrow",
}

export enum TerminateReasonEnum {
  transfer = "transfer",
  leave = "leave",
  terminate = "terminate",
  error = "error",
  refresh = "refresh",
  customerDisconnected = "customerDisconnected",
  conversationEnded = "conversationEnded",
  termsRejected = "termsRejected",
}

export type CobrowseFilterLayoutType = "darkBox" | "blurBox" | "remove";

export enum ErrorCode {
  EVENT_CLIENT_ERROR = 1,
  DEVICE_DETECT_FAILED = 2,
  COPY_TO_CLIPBOARD_FAILED = 3,
  ERROR_LOG_FAILED = 4,
  MEDIA_PLAYER_HTML_PARSE_FAILED = 5,
  GENESYS_API_ERROR = 6,
  DIGITAL_CONNECT_API_ERROR = 7,
  AUTHENTICATION_ERROR = 8,
  RTC_REGISTRATION_ERROR = 9,

  INIT_CHAT_SERVICE_FAILED = 10,
  INIT_MISSING_REQUIRED_PROPERTY = 11,
  INIT_INVALID_PC_ENVIRONMENT = 12,
  INIT_INVALID_REGISTRATION_TYPE = 13,
  INIT_INVALID_GREETING_ACTION = 14,

  COBROWSE_INVALID_PIN = 20,
  COBROWSE_API_ERROR = 21,
  COBROWSE_TERMINATE_FAILED = 21,
  COBROWSE_AUTHENTICATE_FAILED = 22,
  COBROWSE_LEAVE_FAILED = 23,
  COBROWSE_JOIN_FAILED = 24,
  COBROWSE_RESUME_FAILED = 25,
  COBROWSE_DISPLAY_CAPTURE_FAILED = 26,
  COBROWSE_DISPLAY_CAPTURE_PUBLISH_FAILED = 27,
  COBROWSE_CONNECTION_FAILED = 28,

  FILE_TRANSFER_API_ERROR = 30,

  REGISTRATION_INVALID_CUSTOM_FIELDS = 40,
  REGISTRATION_MISSING_CUSTOM_FIELDS = 41,
  REGISTRATION_REQUIRED_FIELD = 42,
  REGISTRATION_INVALID_CUSTOMER_METADATA_FORMAT = 43,
  REGISTRATION_CAPTCHA_FAILED = 44,

  CONVERSATION_START_FAILED = 50,
  CONVERSATION_END_FAILED = 51,
  CONVERSATION_URL_PARSE_FAILED = 52,
  CONVERSATION_URL_MISSING = 53,
  CONVERSATION_JOIN_FAILED = 54,
  CONVERSATION_INVALID_METADATA = 55,
  CONVERSATION_MESSAGE_PARSE_FAILED = 56,
  CONVERSATION_CUSTOMER_CONNECT_FAILED = 57,
  CONVERSATION_TYPING_INDICATOR_FAILED = 58,
  CONVERSATION_MESSAGE_SEND_FAILED = 59,
  CONVERSATION_ESTIMATE_WAIT_TIME_FAILED = 510,

  MEDIA_DEVICES_NOT_AVAILABLE = 60,
  MEDIA_DEVICES_GET_USER_MEDIA_FAILED = 61,
  BROWSER_NOT_SUPPORTED = 62,

  SKETCH_START_FAILED = 70,
  SKETCH_API_ERROR = 71,

  SECURITY_OTP_REQUEST_FAILED = 80,
  SECURITY_CALLBACK_CREATE_FAILED = 81,
  SECURITY_APPLICATION_ID_MISMATCH = 82,

  LOCALE_COUNTRY_CODES_FAILED = 90,
  LOCALE_TRANSLATION_LOAD_FAILED = 91,

  WEB_MESSAGING_BAD_REQUEST = 400,
  WEB_MESSAGING_AUTHENTICATION_FAILED = 401,
  WEB_MESSAGING_FORBIDDEN = 403,
  WEB_MESSAGING_NOT_FOUND = 404,
  WEB_MESSAGING_REQUEST_TIMEOUT = 408,
  WEB_MESSAGING_SESSION_READ_ONLY = 409,
  WEB_MESSAGING_TOO_MANY_REQUESTS_RETRY_LATER = 429,
  WEB_MESSAGING_FILE_TYPE_NOT_SUPPORTED = 4001,
  WEB_MESSAGING_FILE_SIZE_TOO_BIG = 4002,
  WEB_MESSAGING_FILE_CONTENT_INVALID = 4003,
  WEB_MESSAGING_FILE_NAME_INVALID = 4004,
  WEB_MESSAGING_FILE_NAME_TOO_LONG = 4005,
  WEB_MESSAGING_SESSION_EXPIRED = 4006,
  WEB_MESSAGING_SESSION_NOT_FOUND = 4007,
  WEB_MESSAGING_ATTACHMENT_EXPIRED = 4008,
  WEB_MESSAGING_ATTACHMENT_NOT_FOUND = 4009,
  WEB_MESSAGING_ATTACHMENT_UPLOAD_FAILED = 4010,
  WEB_MESSAGING_MESSAGE_LENGTH_TOO_LONG = 4011,
  WEB_MESSAGING_SESSION_CLOSED = 4012,
  WEB_MESSAGING_CUSTOM_ATTRIBUTES_TOO_LARGE = 4013,
  WEB_MESSAGING_TOO_MANY_REQUESTS = 4029,
  WEB_MESSAGING_ATTACHMENT_EMPTY = 4102,
}

export enum NotificationTypeEnum {
  error = "error",
  info = "info",
  warning = "warning",
  success = "success",
  greeting = "greeting",
  confirm = "confirm",
}
